import React, { useState, useRef, useEffect } from 'react'
import styled from 'styled-components'

import { Button } from './Button'

const ExpandableText = ({ children, collapsedHeight = 100 }) => {
  const [expand, setExpand] = useState(false)
  const [shouldShowButton, setShouldShowButton] = useState(false)
  const contentRef = useRef(null)

  useEffect(() => {
    if (contentRef.current) {
      // Show button only if content is taller than collapsedHeight
      setShouldShowButton(contentRef.current.scrollHeight > collapsedHeight)
    }
  }, [children])

  const handleExpand = () => setExpand(!expand)

  return (
    <Container>
      <Content
        ref={contentRef}
        $expand={expand}
        $collapsedHeight={collapsedHeight}
      >
        {children}
      </Content>

      {shouldShowButton && (
        <ExpandContainer>
          <Button handleClick={handleExpand} width="35%" btnClass="primary">
            Read {expand ? 'Less' : 'More'}
          </Button>
        </ExpandContainer>
      )}
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`

const Content = styled.div`
  overflow: hidden;
  transition: max-height 0.3s ease;
  max-height: ${({ $expand, $collapsedHeight }) =>
    $expand ? '9999px' : `${$collapsedHeight}px`};
`

const ExpandContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 0.5rem;
`

export default ExpandableText
